<template>
  <vs-dropdown vs-trigger-click class="cursor-pointer">
    <vs-button class="btn-drop" type="filled" icon="more_vert" icon-after
      >Actions</vs-button
    >
    <vs-dropdown-menu>
      <vs-dropdown-group vs-label="Mark booking as">
        <vs-dropdown-item
          v-for="(action, index) in bookingActions"
          :key="'booking-action-' + index"
          @click="handleBookingActionSelected(action)"
          :disabled="action.disabled"
        >
          <div class="flex items-center w-48 p-2">
            <feather-icon :icon="action.icon" v-if="action.icon" />
            <span class="ml-2">{{ action.name }}</span>
          </div>
        </vs-dropdown-item>
      </vs-dropdown-group>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import { ARRIVAL_STATE, BOOKING_TYPE_TAG } from "@/store/modules/marcom/data-model/bookings";

export default {
  components: {},
  props: {
  },
  data() {
    return {
      ARRIVAL_STATE,
      bookingActions: this.buildActions()
    }
  },
  mounted() {
  },
  methods: {
    handleBookingActionSelected(arrivalState) {
      this.$emit('booking-action-selected', arrivalState);
    },
    buildActions() {
      let arrivalStates = ARRIVAL_STATE.getAll();
      let actions = arrivalStates.map(a => {
        return {
          type: 'ARRIVAL_STATE',
          value: a,
          name: ARRIVAL_STATE.nameof(a),
          icon: ARRIVAL_STATE.iconof(a),
          color: ARRIVAL_STATE.colorof(a),
          disabled: !this.hasPermissionForActiveVenue('vp.vp.booking.handleguestarrival')
        }
      });

      actions.push({
        type: 'BOOKING_TYPE_TAG',
        value: BOOKING_TYPE_TAG.AwaitsConfirmation,
        name: BOOKING_TYPE_TAG.nameof(BOOKING_TYPE_TAG.AwaitsConfirmation),
        icon: BOOKING_TYPE_TAG.iconof(BOOKING_TYPE_TAG.AwaitsConfirmation),
        color: BOOKING_TYPE_TAG.colorof(BOOKING_TYPE_TAG.AwaitsConfirmation),
        disabled: !this.hasPermissionForActiveVenue('vp.vp.booking.editbookings')
      });

      actions.push({
        type: 'BOOKING_TYPE_TAG',
        value: BOOKING_TYPE_TAG.Ended,
        name: 'End booking',
        icon: BOOKING_TYPE_TAG.iconof(BOOKING_TYPE_TAG.Ended),
        color: BOOKING_TYPE_TAG.colorof(BOOKING_TYPE_TAG.Ended),
        disabled: !this.hasPermissionForActiveVenue('vp.vp.booking.editbookings')
      });

      return actions;
    }
  }
};
</script>

<style lang="scss" scoped>
.con-vs-dropdown--menu {
  z-index: 54000;
}
</style>
